"use strict";
// import type { FunctionHandler } from '../../../../../types/nodeEngine';
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXT = void 0;
exports.TEXT = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: (inputs) => {
        const [text, textFormat] = inputs;
        // Date handling
        if (textFormat !== 'yyyy-mm-dd') {
            return {
                error: `Unhandled format for TEXT() function, received: TEXT([text: ${text}], [text_format: ${textFormat}])`,
            };
        }
        return { error: null, result: text };
    },
};
//# sourceMappingURL=text.js.map